import React from "react";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import KioskShopItem from "./KioskShopItem";
import {
  categorizeArrByKey,
  filterByKey,
  filterBySearch,
  filterObjByKey,
  isEmptyObj,
} from "../../../utils/utils";
import styles from "./KioskShopList.module.css";
import KioskShopListSkeleton from "./skeleton/KioskShopListSkeleton";
import ScrollContent from "../../UI/ScrollContent";
import { screenKeys } from "config/constants";
import languages from "languages/languages";
import playClickSpecial from "utils/playClickSpecial";
import slugify from "slugify";

const KioskShopList = ({ shops, loading }) => {
  const history = useHistory();
  const pathname = history.location.pathname.replace(/\/+$/, "");

  const floorState = useSelector((state) => state.filter.filterByFloor);
  const searchState = useSelector((state) => state.filter.filterByName);
  const catState = useSelector((state) => state.filter.filterByCategory);
  const langState = useSelector((state) => state.language.lang);
  const noResultText = languages[langState]["Không có kết quả phù hợp"];

  let filterShop = shops;
  let filterShopElm = null;

  // console.log('filterShop', filterShop)

  if (!shops || loading) {
    return <KioskShopListSkeleton mutilRow={floorState || catState} />;
  }

  if (!searchState && !floorState && !catState) {
    history.push("/" + screenKeys.kiosk);
  }

  const convertEntoVi = (str) =>
    slugify(str, { locale: "vi", lower: true, replacement: " " });

  if (searchState) {
    const filterShopByTags = filterShop.filter((item) => {
      let tags = item.tags;
      let splitTags = [];
      if (tags) {
        splitTags = tags.split(",");
      }
      let filter = splitTags.filter(
        (el) => convertEntoVi(el).indexOf(searchState.trim().toLowerCase()) >= 0
      );

      return filter.length > 0;
    });
    if (filterShopByTags.length === 0) {
      const filterShopByName = filterBySearch(filterShop, "title", searchState);
      filterShop = filterShopByName;
    } else {
      filterShop = filterShopByTags;
    }
  }

  if (floorState || catState) {


    let title = "";
    if (catState) {
      filterShop = filterByKey(filterShop, "category_id", catState.id);
      title = catState.name;
      filterShop = categorizeArrByKey(filterShop, "floor_name");
      if (floorState) {
        filterShop =
          langState === "vi"
            ? filterObjByKey(filterShop, floorState.name)
            : filterObjByKey(filterShop, floorState.trans_name);
      }
    } else {
      filterShop = filterByKey(filterShop, "floor_code", floorState.code);
      filterShop = categorizeArrByKey(filterShop, "category_name");
      title = floorState.name;
    }

    filterShopElm = (
      <>
        <h2
          className={styles.Title}
          dangerouslySetInnerHTML={{ __html: `${title}` }}
        ></h2>
        <div className={styles.List}>
          <ScrollContent mr={20}>
            {!isEmptyObj(filterShop) ? (
              Object.keys(filterShop).map((key, index) => {
                return (
                  <div className={styles.ShopGroup} key={key}>
                    <div style={{ display: "flex" }}>
                      <h3
                        style={{ width: "35%" }}
                        className={styles.GroupTitle}
                        dangerouslySetInnerHTML={{ __html: `${key}` }}
                      ></h3>
                      {index === 0 && (
                        <p style={{ marginLeft: "20px" }}>
                          {languages[langState]["title1"]}
                        </p>
                      )}
                    </div>

                    <div className="row shop-row">
                      {filterShop[key] &&
                        filterShop[key].map((shop, index) => (
                          <div
                            className="col-3"
                            key={`${shop.id}-${shop.code}`}
                          >
                            <Link
                              to={{
                                pathname: `${pathname}/${shop.id}`,
                                search: `?code=${shop.code}&floorName=${shop.floor_name}&slot=${shop.slot}`,
                              }}
                              onClick={playClickSpecial}
                            >
                              <KioskShopItem
                                title={shop.title}
                                logo={shop.logo}
                                promotionTag={shop.promotion_tag}
                                floorName={shop.floor_name}
                                slot={shop.slot}
                              />
                            </Link>
                          </div>
                        ))}
                    </div>
                  </div>
                );
              })
            ) : (
              <p className="font-weight-bold ml-2">{noResultText}</p>
            )}
          </ScrollContent>
        </div>
      </>
    );
  } else {
    filterShopElm = (
      <ScrollContent mr={20}>
        <div className="row shop-row">
          {filterShop.length ? (
            filterShop.map((shop) => (
              <div className="col-3" key={`${shop.id}-${shop.code}`}>
                <Link
                  to={{
                    pathname: `${pathname}/${shop.id}`,
                    search: `?code=${shop.code}&floorName=${shop.floor_name}&slot=${shop.slot}`,
                  }}
                  onClick={playClickSpecial}
                >
                  <KioskShopItem
                    title={shop.title}
                    logo={shop.logo}
                    promotionTag={shop.promotion_tag}
                    floorName={shop.floor_name}
                    slot={shop.slot}
                  />
                </Link>
              </div>
            ))
          ) : (
            <p className="font-weight-bold ml-2">{noResultText}</p>
          )}
        </div>
      </ScrollContent>
    );
  }

  return filterShopElm;
};

export default KioskShopList;
